import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import 'codemirror/mode/css/css';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/xml/xml';
import { ExceptionsService } from '../../services/utelize/general/exceptions-service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-comp-html-editor-viewer',
  templateUrl: './page-comp-html-editor-viewer.component.html',
  styleUrls: ['./page-comp-html-editor-viewer.component.scss']
})

export class PageCompHtmlEditorViewerComponent implements AfterViewInit, OnChanges, OnInit {

  @Input() isHtmlAuthor: boolean=false;
  @Input() itemHtml    : string | undefined;

  @Input() set viewAsSourceInput(value: boolean) { this.viewAsSource=value; }

  @Output() htmlSave          =new EventEmitter<string>();
  @Output() viewAsSourceChange=new EventEmitter<boolean>();

  @ViewChild('contentHost', { static: false }) contentHost!: ElementRef<HTMLDivElement>;

  public viewAsSource: boolean=false;

  public codemirrorOptions={
    lineNumbers : true,
    lineWrapping: true,
    mode        : "text/html",
  };

  constructor(
    private exceptionsService: ExceptionsService,
    private router           : Router
  ) { }

  public ngOnInit(): void {
    try {
      
    }
    catch (e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.applyResponsiveImages();
    }
    catch (e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    try {
      if (changes["itemHtml"] && !this.viewAsSource) {
        setTimeout(() => this.applyResponsiveImages());
      }
    }
    catch (e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onHtmlSaveClick(): void {
    try {
      this.htmlSave.emit(this.itemHtml ?? "");
    }
    catch (e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public toBodyHtml(fullHtml: string | undefined): string {
    try {
      const doc=new DOMParser().parseFromString(<string>fullHtml, "text/html");
      
      return doc.body?.innerHTML ?? fullHtml;
    }
    catch (e) {
      this.exceptionsService.handleException(<Error>e);
      return <string>fullHtml;
    }
  }

  private applyResponsiveImages(): void {
    try {
      if (!this.contentHost)
        return;
      
      requestAnimationFrame(() => {
        const host=this.contentHost.nativeElement;
        const imgs=host.querySelectorAll('img');

        imgs.forEach(img => {
          img.removeAttribute('height');
          img.removeAttribute('width');

          (img as HTMLImageElement).style.width    ='100%';
          (img as HTMLImageElement).style.maxWidth ='100%';
          (img as HTMLImageElement).style.height   ='auto';
          (img as HTMLImageElement).style.display  ='block';
          (img as HTMLImageElement).style.objectFit='contain';

          const p=img.parentElement;

          if (p && p.tagName==='A') {
            (p as HTMLElement).style.display='block';
            (p as HTMLElement).style.width  ='100%';
          }

          if (!(img as HTMLImageElement).complete) {
            img.addEventListener('load', () => {
              (img as HTMLImageElement).style.width ='100%';
              (img as HTMLImageElement).style.height='auto';
            }, { once: true });
          }
        });
      });
    }
    catch (e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onViewToggle(isSource: boolean): void {
    try {
      this.viewAsSource=isSource;
      this.viewAsSourceChange.emit(isSource);

      if (!isSource) {
        setTimeout(() => this.applyResponsiveImages());
      }
    }
    catch (e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onHostClick(event: MouseEvent): void {
    try {
      if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)
        return;

      const anchor=(event.target as HTMLElement)?.closest?.('a') as HTMLAnchorElement | null;

      if (!anchor)
        return;

      if (anchor.target==='_blank')
        return;

      const href=anchor.getAttribute('href') || '';

      if (!href)
        return;
      
      if (href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('#'))
        return;

      const url=new URL(href, window.location.origin);

      if (url.origin !== window.location.origin)
        return;

      event.preventDefault();
      event.stopPropagation();

      const match=url.pathname.match(/^\/support\/support-help\/item\/([^\/\?#]+)$/);

      if (match && match[1]) {
        const id=match[1];
        this.router.navigate(['/', 'support', 'support-help', 'item', id]).catch(() => {});
        return;
      }

      const absolutePath=url.pathname+url.search+url.hash;
      this.router.navigateByUrl(absolutePath).catch(() => {});
    } catch (e) {
      this.exceptionsService.handleException(e as Error);
    }
  }
}
